import { API } from '../constants/api-urls';
import axios from '../requester';
import _ from 'lodash';
import { PDT_PAGE_SIZE } from 'views/root/views/home/views/projects/ProjectsApi/projects.consts';

export const PDT_VIEW_TYPES = {
  DEFAULT: 'default',
  LIGHT: 'light'
};

export const getLastUpdated = async ({ projectId = null } = {}) => {
  if (projectId) {
    return axios.get(`${API.PDT_PROJECTS}/${projectId}/last-updated`);
  }
  return axios.get(`${API.PDT_PROJECTS}/last-updated`);
};

export const getPdtProjectsV2 = async ({
  selectedPeriod,
  timeRange,
  page = 1,
  limit = PDT_PAGE_SIZE,
  projectIds = [],
  view = PDT_VIEW_TYPES.DEFAULT,
  keyword = ''
} = {}) => {
  const startDate = _.get(timeRange, 'start_date');
  const endDate = _.get(timeRange, 'end_date');
  const payload = {
    duration_filter: selectedPeriod,
    limit,
    page,
    start_date: startDate,
    end_date: endDate,
    project_ids: projectIds,
    view,
    keyword
  };
  const queryParams = {};
  if (view === PDT_VIEW_TYPES.LIGHT) {
    queryParams.mp = true;
  }
  const response = await axios.post(API.PDT_PROJECTS, payload, {
    params: queryParams
  });
  return response;
};

export const getPdtProject = async ({ projectId, queryParams }) => {
  return axios.get(`${API.PDT_PROJECTS}/${projectId}?${queryParams}`);
};

export const getIssuesCountsV2 = async payload => {
  return axios.post(`${API.PDT_ISSUES_V2_PATH}/totals`, payload);
};

export const getIssuesSummaryV2 = async payload => {
  return axios.post(`${API.PDT_ISSUES_V2_PATH}/summary`, payload);
};

export const getIssuesV2 = async payload => {
  return axios.post(`${API.PDT_ISSUES_V2_PATH}`, payload);
};

export const checkProjectsUpdates = async payload => {
  return axios.post(`${API.PDT_PROJECTS}/status-check`, payload);
};

export const getProjectIterations = async projectUuid => {
  return axios.get(`${API.PDT_PROJECTS}/${projectUuid}/iterations`);
};

export const getProjectContributors = async ({ projectUuid, queryParams }) => {
  return axios.get(
    `${API.PDT_PROJECTS}/${projectUuid}/contributors?${queryParams}`
  );
};
